// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__YbESu","pink":"About_pink__ng6cr","green":"About_green__6kojl","skills":"About_skills__qDee7"};